import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  BackButton,
  CancelButton,
  SaveButton,
} from "../../components/common/MainButtonComponent";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { routes } from "../../helper/routes";
import "./AssessShared.css";
import "./SetupAssessment.css";

export default function SetupAssessmentPartEditPage({
  part: providedPart,
  setOpenPartEdit,
  editDetails,
}) {
  const history = useHistory();
  const location = useLocation();
  const { id, partId } = useParams();
  const part = location.state?.part;
  const activePart = providedPart || part;

  //console.log("SetupAssessmentPartEditPage -> activePart", activePart);

  const fallbackTitle = useMemo(
    () => `Part ${String(partId || "").replace("part-", "") || "Details"}`,
    [partId]
  );

  const [title, setTitle] = useState(activePart?.title || fallbackTitle);
  const [displayOrder, setDisplayOrder] = useState(activePart?.displayOrder || "1");
  const [sectionCount, setSectionCount] = useState( String(activePart?.noOfSections ?? activePart?.sections?.length ?? 0) );
  const [allowInstructions, setAllowInstructions] = useState(Boolean(activePart?.allowInstructions ));
  const [instructions, setInstructions] = useState(
    activePart?.allowInstructions ? activePart?.instructions : ""
  );

  useEffect(() => {
    setTitle(activePart?.title || fallbackTitle);
    setDisplayOrder(activePart?.displayOrder || "1");
    setSectionCount(String(activePart?.noOfSections ?? activePart?.sections?.length ?? 0));
    setAllowInstructions(Boolean(activePart?.allowInstructions ));
    setInstructions(activePart?.allowInstructions ? activePart?.instructions : "");
  }, [activePart, fallbackTitle]);

  const goBack = () => {
    if (typeof setOpenPartEdit === "function") {
      setOpenPartEdit(null);
      return;
    }

    history.push(`${routes.asses_lib}/setup/${id}`);
  };

  const updatePart = async () => {
    const payload = {
      id: activePart?.id,
      assessmentPartId: activePart?.assessmentPartId,
      title,
      // displayOrder: Number(displayOrder) || 1,
      sectionsCount: Number(sectionCount) || 0,
      allowInstructions,
      instructions,
    };
    if (typeof editDetails === "function") {
      await editDetails(payload);
      return;
    }

    goBack();
  };

  return (
    <ContentWrapper>
      <section className="assess-section setup-meta-page">
        <div className="setup-meta-page__actions">
          <BackButton label="Back" onClick={goBack} />
        </div>

        <div className="setup-meta-card">
          <div className="setup-meta-card__header">
            <h1>Update Part &apos;{title}&apos; Details</h1>
          </div>

          <div className="setup-meta-card__body">
            <div className="row g-3">
              <div className="col-12">
                <label className="setup-meta-field">
                  <span>Part Title *</span>
                  <input
                    value={title}
                    onChange={(event) => setTitle(event.target.value)}
                  />
                </label>
              </div>

              <div className="col-12 col-lg-6">
                <label className="setup-meta-field">
                  <span>Display Order</span>
                  <input
                    type="number"
                    value={displayOrder}
                    // onChange={(event) => setDisplayOrder(event.target.value)}
                    disabled
                    readOnly
                  />
                </label>
              </div>

              <div className="col-12 col-lg-6">
                <label className="setup-meta-field">
                  <span>No of Sections *</span>
                  <input
                    type="number"
                    min="0"
                    value={sectionCount}
                    onChange={(event) => setSectionCount(event.target.value)}
                  />
                </label>
              </div>

              <div className="col-12">
                <label className="setup-meta-check">
                  <input
                    type="checkbox"
                    checked={allowInstructions}
                    onChange={(event) =>
                      {
                        const nextChecked = event.target.checked;
                        setAllowInstructions(nextChecked);
                        if (!nextChecked) {
                          setInstructions("");
                        }
                      }
                    }
                  />
                  <span>Allow Part Instructions</span>
                </label>
              </div>

              {allowInstructions ? (
                <div className="col-12">
                  <label className="setup-meta-field">
                    <span>Part Instructions *</span>
                    <textarea
                      rows="7"
                      value={instructions}
                      onChange={(event) => setInstructions(event.target.value)}
                    />
                  </label>
                </div>
              ) : null}
            </div>
          </div>

          <div className="setup-meta-card__footer">
            <CancelButton label="Cancel" onClick={goBack} />
            <SaveButton label="Update" onClick={updatePart} />
          </div>
        </div>
      </section>
    </ContentWrapper>
  );
}
